import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import { ReactComponent as DocumentAddIconSvg } from '../../assets/document-add.svg';
import Icon from '@ant-design/icons';

export const DocumentAddIcon = (props: Partial<CustomIconComponentProps>): JSX.Element => {
  return <Icon component={DocumentAddIconSvg} {...props} />;
};
